import React, { Component } from 'react';
import { Button, Popconfirm, message, Modal, Spin, Table } from 'antd';
import { TokenActionOrPlan } from './Widget';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Filter from './Filter';
import renderEnhancer from '../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';

class Page extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        fileModalVisible: false,
        fileList: [],
        fileLoading: false,
        currentFileRecord: null,
        canAddFromApi: false,
        suspiciousModalVisible: false,
        suspiciousModalTitle: '',
        suspiciousModalType: '', // 'raise' or 'reply'
        suspiciousContent: '',
        currentSuspiciousRecord: null,
        lastSuspiciousContent: '', // 最近一次提出质疑的内容（回复质疑时展示）
        recallModalVisible: false,
        recallContent: '',
        currentRecallRecord: null,
        logModalVisible: false,
        logData: [],
        logLoading: false,
    }

    fileUploadRef = null;

    setFileUploadRef = (el) => {
        this.fileUploadRef = el;
    }

    componentDidMount() {
        const { majorEventNumber, primaryEventNumber } = sessionStorage;
        const searchParams = { ...this.state.searchParams };
        if (majorEventNumber) {
            searchParams.majorEventNumber = majorEventNumber;
        }
        if (primaryEventNumber) {
            searchParams.primaryEventNumber = primaryEventNumber;
        }
        this.setState({ searchParams }, () => {
            this.loadData();
        })
        this.queryInvestigationStageByInvId();
        this.queryCanAddMajorEvent();
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.status && this.props.status) {
            this.loadData();
        }
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.execute.queryListByParams,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
                sessionStorage.removeItem('majorEventNumber');
                sessionStorage.removeItem('primaryEventNumber');
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = (majorEventId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.delMajorEvent,
            data: { majorEventId },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        const url = API_URL.execute.exportMajorEvent;
        ExportUtil.export({ ...sortParams, ...params }, null, url);
    }

    downloadWord = (majorEventId) => {
        const url = API_URL.execute.exportMajorEventWord;
        ExportUtil.export({ majorEventId }, null, url);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        if(!investigationId) return
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    queryCanAddMajorEvent = () => {
        const { invId, siteId } = sessionStorage;
        if (!invId) return;
        const options = {
            method: 'POST',
            url: API_URL.execute.queryJudgeCanAddMajorEvent,
            data: { invId, siteId: siteId > 0 ? siteId : undefined },
            dataType: 'json',
            doneResult: res => {
                this.setState({ canAddFromApi: res.canAdd === true });
            },
        };
        $.sendRequest(options);
    }

    showFileModal = (record) => {
        this.setState({
            fileModalVisible: true,
            currentFileRecord: record,
        }, () => {
            this.loadFileList(record.majorEventId);
        });
    }

    hideFileModal = () => {
        this.setState({
            fileModalVisible: false,
            fileList: [],
            currentFileRecord: null,
        });
    }

    loadFileList = (majorEventId) => {
        this.setState({ fileLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.queryOssFileList,
            data: { relateId: majorEventId, uploadType: 'MAJOR_EVENT_FILE' },
            dataType: 'json',
            doneResult: res => {
                const list = res.datas || [];
                this.setState({
                    fileLoading: false,
                    fileList: list,
                });
            },
            errorResult: () => {
                this.setState({ fileLoading: false });
            }
        };
        $.sendRequest(options);
    }

    handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const { currentFileRecord } = this.state;
        const { majorEventId } = currentFileRecord;

        this.setState({ fileLoading: true });

        const formData = new FormData();
        formData.append('file', file);
        formData.append('majorEventId', majorEventId);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', API_URL.execute.uploadMajorEventFile, true);

        const tokenName = localStorage.tokenName;
        const tokenValue = localStorage.tokenValue;
        const loginType = localStorage.loginType || 'ADFS';
        if (tokenName && tokenValue) {
            xhr.setRequestHeader(tokenName, tokenValue);
        }
        xhr.setRequestHeader('loginType', loginType);

        xhr.onload = () => {
            this.setState({ fileLoading: false });
            if (this.fileUploadRef) {
                this.fileUploadRef.value = '';
            }

            if (xhr.status === 200) {
                try {
                    const result = JSON.parse(xhr.responseText);
                    if (result.success) {
                        message.success(result.success || '上传成功');
                        this.loadFileList(majorEventId);
                    } else {
                        message.error(result.error || '上传失败');
                    }
                } catch (err) {
                    message.error('上传失败');
                }
            } else {
                message.error('上传失败');
            }
        };

        xhr.onerror = () => {
            this.setState({ fileLoading: false });
            if (this.fileUploadRef) {
                this.fileUploadRef.value = '';
            }
            message.error('上传失败');
        };

        xhr.send(formData);
    }

    handleFileDownload = (fileId) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id: fileId }, null, url);
    }

    handleFileDelete = (fileId) => {
        this.setState({ fileLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.deleteOssFile,
            data: { id: fileId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ fileLoading: false });
                message.success(res.success || '删除成功');
                const { currentFileRecord } = this.state;
                if (currentFileRecord) {
                    this.loadFileList(currentFileRecord.majorEventId);
                }
            },
            errorResult: () => {
                this.setState({ fileLoading: false });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    filterDate = (text) => text ? text.slice(0, 10) : '';

    handleStringLinefeed = (text) => {
        const arr = (text || '').split('；');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ';' : ''}<br /></span>;
        });
        return result;
    }

    getColumns = (canEdit) => {
        const columns = [{
            title: '重大事件编号',
            dataIndex: 'primaryEventNumber',
            key: 'primaryEventNumber',
            fixed: 'left',
            width: 100,
        }, {
            title: '重大事件单号',
            dataIndex: 'majorEventNumber',
            key: 'majorEventNumber',
            fixed: 'left',
            width: 100,
        }, {
            title: '报告类型',
            dataIndex: 'reportTypeShow',
            key: 'reportTypeShow',
            fixed: 'left',
            width: 80,
        }, {
            title: '事件归属类型',
            dataIndex: 'eventType',
            key: 'eventType',
            width: 240,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {eventType } = record;
                        const eventTypeList = (eventType || '').split('；');
                        if ((eventTypeList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        eventTypeList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split('；')[0].substring(0,30):'')
            ),
        }, {
            title: '事件发生时间',
            dataIndex: 'eventHappenDate',
            key: 'eventHappenDate',
            width: 100,
            render: this.filterDate,
        }, {
            title: '事件获知时间',
            dataIndex: 'eventKnowDate',
            key: 'eventKnowDate',
            width: 100,
            render: this.filterDate,
        }, {
            title: '事件报告时间',
            dataIndex: 'eventReportDate',
            key: 'eventReportDate',
            width: 100,
            render: this.filterDate,
        }, {
            title: '报告人',
            dataIndex: 'reportUserName',
            key: 'reportUserName',
            width: 80,
        }, {
            title: '上报PM/LM时间',
            dataIndex: 'reportToPmLmDate',
            key: 'reportToPmLmDate',
            width: 120,
            render: this.filterDate,
        }, {
            title: '上报QA时间',
            dataIndex: 'reportToQaDate',
            key: 'reportToQaDate',
            width: 100,
            render: this.filterDate,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {investigationName } = record;
                            if( (investigationName || '').length > 30 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{investigationName}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,30):'')
            ),
        }, {
            title: '研究产品名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
            width: 160,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {investigationSpecialName } = record;
                            if( (investigationSpecialName|| '').length > 25 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{investigationSpecialName}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,25):'')
            ),
        }, {
            title: '研究方案名称',
            dataIndex: 'researchProtocolName',
            key: 'researchProtocolName',
            width: 160,
        }, {
            title: '方案编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 120,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {leaderNameCode } = record;
                        const leaderNameCodeList = (leaderNameCode || '').split(';');
                        if ((leaderNameCodeList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        leaderNameCodeList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(';')[0]:'')
            ),
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeShow',
            key: 'investigationMedicineTypeShow',
            width: 100,
        }, {
            title: '给药方式',
            dataIndex: 'administrationModeName',
            key: 'administrationModeName',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 120,
        }, {
            title: 'CRO',
            dataIndex: 'croName',
            key: 'croName',
            width: 120,
        }, {
            title: '津石PM',
            dataIndex: 'pmNames',
            key: 'pmNames',
            width: 80,
        }, {
            title: '申办方PM',
            dataIndex: 'sponsorPm',
            key: 'sponsorPm',
            width: 80,
        }, {
            title: 'CRO PM',
            dataIndex: 'croPm',
            key: 'croPm',
            width: 80,
        }, {
            title: '涉及层面',
            dataIndex: 'influenceLevelShow',
            key: 'influenceLevelShow',
            width: 80,
        }, {
            title: '涉及研究中心',
            dataIndex: 'siteNames',
            key: 'siteNames',
            width: 120,
        }, {
            title: 'CRC',
            dataIndex: 'crcNameCodes',
            key: 'crcNameCodes',
            width: 120,
            render: this.handleStringLinefeed,
        }, {
            title: 'CRC直线主管',
            dataIndex: 'leaderNameCodes',
            key: 'leaderNameCodes',
            width: 120,
            render: this.handleStringLinefeed,
        }, {
            title: '重大事件可能造成的影响',
            dataIndex: 'possibleImpact',
            key: 'possibleImpact',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {possibleImpact } = record;
                        const possibleImpactList = (possibleImpact || '').split('；');
                        if ((possibleImpactList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        possibleImpactList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split('；')[0].substring(0,30):'')
            ),
        }, {
            title: '项目或方案要求描述',
            dataIndex: 'projectSchemeDescription',
            key: 'projectSchemeDescription',
            width: 80,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {projectSchemeDescription } = record;
                            if( (projectSchemeDescription || '').length > 10 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{projectSchemeDescription}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,10):'')
            ),
        }, {
            title: '实际操作情况',
            dataIndex: 'actualOperation',
            key: 'actualOperation',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {actualOperation } = record;
                            if( (actualOperation || '').length > 12 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{actualOperation}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,12):'')
            ),
        }, {
            title: '目前对受试者及研究中心的影响',
            dataIndex: 'impactToSubjectsSite',
            key: 'impactToSubjectsSite',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {impactToSubjectsSite } = record;
                            if( (impactToSubjectsSite || '').length > 15 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{impactToSubjectsSite}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,15):'')
            ),
        }, {
            title: '已采取的措施或计划',
            dataIndex: 'majorMeasurePlan',
            key: 'majorMeasurePlan',
            width: 80,
            render: (text, record) => {
                return <a onClick={() => this.viewDetail(record)}>查看详情</a>
            }
        }, {
            title: '重大事件处理结束与否',
            dataIndex: 'majorDealIsEndShow',
            key: 'majorDealIsEndShow',
            width: 100,
        }, {
            title: '最终处理情况及影响',
            dataIndex: 'finalImpactShow',
            key: 'finalImpactShow',
            width: 140,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const { finalImpactShow } = record;
                        if ((finalImpactShow || '').length > 12) {
                            return (
                                <div style={{ width:400, wordWrap:'break-word' }}>{finalImpactShow}</div>
                            );
                        }
                    }
                })(text => text ? text.substring(0, 12) : '')
            ),
        }, {
            title: '重大事件状态',
            dataIndex: 'eventStatusShow',
            key: 'eventStatusShow',
            width: 80,
        }, {
            title: '质疑状态',
            dataIndex: 'suspiciousStatusShow',
            key: 'suspiciousStatusShow',
            width: 80,
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 160,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            width: 150,
            render: (text, record) => {
                const { canEdit: crcCanEdit, canDelete, majorEventId, eventStatus, suspiciousStatus } = record;
                const isNewOrCancelWithdrawal = eventStatus === 'NEW' || eventStatus === 'CANCEL_WITHDRAWAL';
                const isWithdrawn = eventStatus === 'WITHDRAWN';
                const suspiciousEmptyOrRepliedOrCancel = !suspiciousStatus || suspiciousStatus === 'REPLIED' || suspiciousStatus === 'CANCEL_SUSPICIOUS';
                const suspiciousEmptyOrReplied = !suspiciousStatus || suspiciousStatus === 'REPLIED' || suspiciousStatus === 'CANCEL_SUSPICIOUS';
                const isPendingReply = suspiciousStatus === 'PENDING_REPLY';
                const canSuspicious = window.sessionStorage.canSuspicious === 'true';

                return (
                    <span>
                        <a onClick={() => this.props.onChange(record, 'view')}>查看</a>
                        <span className="ant-divider" />
                        {
                            (canEdit && crcCanEdit) &&
                            <span>
                                <a onClick={() => this.canEditByInvStatus(() => this.props.onChange(record, 'edit'))}>修改</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            canDelete && suspiciousStatus !== 'PENDING_REPLY' &&
                            <span>
                                <Popconfirm title="确定删除该条重大事件?" onConfirm={() => this.canEditByInvStatus(() => this.delete(majorEventId))}>
                                    <a>删除</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                            </span>
                        }
                        {/* 事件撤回：eventStatus = NEW 或 CANCEL_WITHDRAWAL 且 suspiciousStatus 为空/REPLIED/CANCEL_SUSPICIOUS */}
                        {canDelete && isNewOrCancelWithdrawal && suspiciousEmptyOrRepliedOrCancel && (
                            <span>
                                <a onClick={() => this.showRecallModal(record)}>事件撤回</a>
                                <span className="ant-divider" />
                            </span>
                        )}
                        {/* 取消事件撤回：eventStatus = WITHDRAWN */}
                        {canDelete && isWithdrawn && (
                            <span>
                                <Popconfirm title="确定取消事件撤回?" onConfirm={() => this.handleCancelWithdrawnEvent(majorEventId)}>
                                    <a>取消事件撤回</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                            </span>
                        )}
                        {/* 提出质疑：eventStatus = NEW 或 CANCEL_WITHDRAWAL 且 suspiciousStatus 为空/REPLIED 且 canSuspicious = true */}
                        {isNewOrCancelWithdrawal && suspiciousEmptyOrReplied && canSuspicious && (
                            <span>
                                <a onClick={() => this.showSuspiciousModal(record, 'raise')}>提出质疑</a>
                                <span className="ant-divider" />
                            </span>
                        )}
                        {/* 撤回质疑：eventStatus = NEW 或 CANCEL_WITHDRAWAL 且 suspiciousStatus = PENDING_REPLY 且 canSuspicious = true */}
                        {isNewOrCancelWithdrawal && isPendingReply && canSuspicious && (
                            <span>
                                <Popconfirm title="确定撤回质疑?" onConfirm={() => this.handleWithdrawnSuspicious(majorEventId)}>
                                    <a>撤回质疑</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                            </span>
                        )}
                        {/* 回复质疑：eventStatus = NEW 或 CANCEL_WITHDRAWAL 且 suspiciousStatus = PENDING_REPLY 且当前用户在 pmPmLeaderCrcLeaderIds 中 */}
                        {isNewOrCancelWithdrawal && isPendingReply && record.pmPmLeaderCrcLeaderIds && record.pmPmLeaderCrcLeaderIds.includes(Number(sessionStorage.userId)) && (
                            <span>
                                <a onClick={() => this.showSuspiciousModal(record, 'reply')}>回复质疑</a>
                                <span className="ant-divider" />
                            </span>
                        )}
                        <a onClick={() => this.downloadWord(majorEventId)}>下载Word</a>
                        <span className="ant-divider" />
                        <a onClick={() => this.showFileModal(record)}>附件</a>
                        <span className="ant-divider" />
                        <a onClick={() => this.showLogModal(record)}>操作日志</a>
                    </span>
                )
            }
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    viewDetail = (record) => {
        this.tokenActionOrPlanRef.show(record);
    }

    // 显示事件撤回弹窗
    showRecallModal = (record) => {
        this.setState({
            recallModalVisible: true,
            recallContent: '',
            currentRecallRecord: record,
        });
    }

    // 关闭事件撤回弹窗
    handleRecallCancel = () => {
        this.setState({
            recallModalVisible: false,
            recallContent: '',
            currentRecallRecord: null,
        });
    }

    // 撤回内容变更
    onRecallContentChange = (e) => {
        this.setState({ recallContent: e.target.value });
    }

    // 是否可点击确认撤回
    isRecallConfirmDisabled = () => {
        const { recallContent } = this.state;
        return !recallContent || !recallContent.trim();
    }

    // 确认事件撤回
    handleRecallOk = () => {
        const { recallContent, currentRecallRecord } = this.state;
        if (!recallContent || !recallContent.trim()) {
            message.warning('请输入撤回原因');
            return;
        }
        const { majorEventId } = currentRecallRecord;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.withdrawnEvent,
            data: { majorEventId, recallContent: recallContent.trim() },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '事件撤回成功');
                this.setState({
                    loading: false,
                    recallModalVisible: false,
                    recallContent: '',
                    currentRecallRecord: null,
                }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    // 取消事件撤回
    handleCancelWithdrawnEvent = (majorEventId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.cancelWithdrawnEvent,
            data: { majorEventId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '取消事件撤回成功');
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    // 撤回质疑
    handleWithdrawnSuspicious = (majorEventId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.withdrawnSuspicious,
            data: { majorEventId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '撤回质疑成功');
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    // 显示提出质疑/回复质疑弹窗
    showSuspiciousModal = (record, type) => {
        const title = type === 'raise' ? '提出质疑' : '回复质疑';
        this.setState({
            suspiciousModalVisible: true,
            suspiciousModalTitle: title,
            suspiciousModalType: type,
            suspiciousContent: '',
            currentSuspiciousRecord: record,
            lastSuspiciousContent: '',
        });
        // 回复质疑时，查询最近一次提出质疑的内容
        if (type === 'reply') {
            const options = {
                method: 'POST',
                url: API_URL.execute.queryLastSuspiciousContent,
                data: { majorEventId: record.majorEventId },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ lastSuspiciousContent: res.suspiciousContent || '' });
                },
            };
            $.sendRequest(options);
        }
    }

    // 关闭质疑弹窗
    handleSuspiciousCancel = () => {
        this.setState({
            suspiciousModalVisible: false,
            suspiciousModalTitle: '',
            suspiciousModalType: '',
            suspiciousContent: '',
            currentSuspiciousRecord: null,
            lastSuspiciousContent: '',
        });
    }

    // 质疑内容变更
    onSuspiciousContentChange = (e) => {
        this.setState({ suspiciousContent: e.target.value });
    }

    // 确认提出质疑/回复质疑
    handleSuspiciousOk = () => {
        const { suspiciousContent, currentSuspiciousRecord, suspiciousModalType } = this.state;
        if (!suspiciousContent || !suspiciousContent.trim()) {
            message.warning('请输入内容');
            return;
        }
        const url = suspiciousModalType === 'raise'
            ? API_URL.execute.raiseSuspicious
            : API_URL.execute.replySuspicious;

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: url,
            data: {
                majorEventId: currentSuspiciousRecord.majorEventId,
                suspiciousContent: suspiciousContent.trim(),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '操作成功');
                this.setState({
                    loading: false,
                    suspiciousModalVisible: false,
                    suspiciousModalTitle: '',
                    suspiciousModalType: '',
                    suspiciousContent: '',
                    currentSuspiciousRecord: null,
                    lastSuspiciousContent: '',
                }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    // 显示操作日志弹窗
    showLogModal = (record) => {
        this.setState({
            logModalVisible: true,
            logLoading: true,
            logData: [],
        }, () => {
            this.loadLogData(record.majorEventId);
        });
    }

    // 关闭操作日志弹窗
    hideLogModal = () => {
        this.setState({
            logModalVisible: false,
            logData: [],
            logLoading: false,
        });
    }

    // 加载操作日志数据
    loadLogData = (majorEventId) => {
        const options = {
            method: 'POST',
            url: API_URL.execute.querySuspiciousListByEventId,
            data: { majorEventId, offset: 1, limit: 999 },
            dataType: 'json',
            doneResult: res => {
                const datas = res.datas || [];
                this.setState({
                    logLoading: false,
                    logData: datas,
                });
            },
            errorResult: () => {
                this.setState({ logLoading: false });
            },
        };
        $.sendRequest(options);
    }

    // 操作类型映射
    getTypeDescription = (type) => {
        const map = {
            'RAISE_SUSPICIOUS': '提出质疑',
            'REPLY_SUSPICIOUS': '回复质疑',
            'MODIFY_EVENT': '修改报告',
            'WITHDRAWN_EVENT': '撤回重大事件',
            'CANCEL_SUSPICIOUS': '撤回质疑',
            'CANCEL_WITHDRAWAL': '取消撤回重大事件',
        };
        return map[type] || type;
    }

    render() {
        const { config, maxDate } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        const { siteId, curRole, investigationSiteName } = sessionStorage;
        const isPM = curRole === 'PM';
        const isCRC = curRole === 'CRC';
        const isInProject = !!investigationSiteName;
        const isSingleSite = siteId > 0;
        const roleCanEdit = (!isSingleSite && isPM) || (isSingleSite && (isPM || isCRC));
        const canEdit = isInProject && (roleCanEdit || this.state.canAddFromApi);
        return (
            <div >
                <style>{`
                    .suspicious-textarea {
                        border: 1px solid #1890ff;
                    }
                    .suspicious-textarea:focus {
                        border: 1px solid #1890ff;
                        outline: none;
                        box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
                    }
                    .recall-textarea {
                        border: 1px solid #1890ff;
                    }
                    .recall-textarea:focus {
                        border: 1px solid #1890ff;
                        outline: none;
                        box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
                    }
                `}</style>
                <Filter
                    config={config}
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                        canEdit && <Button key="add" type="primary" onClick={() => this.canEditByInvStatus(() => this.props.onChange({}, 'add'))}>添加</Button>
                    ]}
                />
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns(canEdit)}
                    rowKey="majorEventId"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <TokenActionOrPlan
                    ref={el => this.tokenActionOrPlanRef = el}
                    canEdit={canEdit}
                    maxDate={maxDate}
                    loadData={this.loadData}
                    canEditByInvStatus={this.canEditByInvStatus}
                />
                <Modal
                    title="上传文件"
                    visible={this.state.fileModalVisible}
                    onCancel={this.hideFileModal}
                    maskClosable={false}
                    footer={<Button type="ghost" onClick={this.hideFileModal}>关闭</Button>}
                    width="500px"
                >
                    <Spin spinning={this.state.fileLoading}>
                        {canEdit && this.state.currentFileRecord && this.state.currentFileRecord.canEdit && (
                            <div style={{ marginBottom: 16 }}>
                                <input
                                    type="file"
                                    ref={this.setFileUploadRef}
                                    style={{ display: 'none' }}
                                    onChange={this.handleFileSelect}
                                />
                                <Button
                                    type="primary"
                                    onClick={() => this.fileUploadRef && this.fileUploadRef.click()}
                                >
                                    选择文件
                                </Button>
                            </div>
                        )}
                        <div>
                            {this.state.fileList.length > 0 ? (
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {this.state.fileList.map((file, index) => (
                                        <li key={file.id || index} style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '8px 0',
                                            borderBottom: '1px solid #e8e8e8'
                                        }}>
                                            <a
                                                style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}
                                                onClick={() => this.handleFileDownload(file.id)}
                                                title={file.fileName || file.name || file.originalName || ''}
                                            >
                                                {file.fileName || file.name || file.originalName || ''}
                                            </a>
                                            {canEdit && this.state.currentFileRecord && this.state.currentFileRecord.canEdit && (
                                                <a
                                                    style={{ cursor: 'pointer', marginLeft: 8, color: '#ff4d4f', fontSize: 18, lineHeight: 1 }}
                                                    onClick={() => this.handleFileDelete(file.id)}
                                                >
                                                    ×
                                                </a>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                !this.state.fileLoading && <div style={{ color: '#999', textAlign: 'center', padding: '20px 0' }}>暂无文件</div>
                            )}
                        </div>
                    </Spin>
                </Modal>
                <Modal
                    title={this.state.suspiciousModalTitle}
                    visible={this.state.suspiciousModalVisible}
                    onCancel={this.handleSuspiciousCancel}
                    maskClosable={false}
                    footer={[
                        <Button key="cancel" onClick={this.handleSuspiciousCancel}>取消</Button>,
                        <Button key="confirm" type="primary" loading={this.state.loading} onClick={this.handleSuspiciousOk}>确认</Button>,
                    ]}
                    width="500px"
                >
                    {this.state.suspiciousModalType === 'reply' && (
                        <div style={{ marginBottom: 12, padding: '8px 12px', background: '#f5f5f5', borderRadius: 4, border: '1px solid #e8e8e8' }}>
                            <div style={{ fontWeight: 'bold', marginBottom: 8, color: '#333', fontSize: 16 }}>重大事件成员组提出的质疑</div>
                            {this.state.lastSuspiciousContent && (
                                <div style={{ whiteSpace: 'pre-wrap', color: '#666', fontSize: 16, lineHeight: 1.8 }}>{this.state.lastSuspiciousContent}</div>
                            )}
                        </div>
                    )}
                    <textarea
                        className="suspicious-textarea"
                        value={this.state.suspiciousContent}
                        onChange={this.onSuspiciousContentChange}
                        style={{ width: '100%', height: 200, resize: 'vertical' }}
                        placeholder="请输入内容"
                    />
                </Modal>
                <Modal
                    title="撤回重大事件"
                    visible={this.state.recallModalVisible}
                    onCancel={this.handleRecallCancel}
                    maskClosable={false}
                    footer={[
                        <Button key="cancel" onClick={this.handleRecallCancel}>取消</Button>,
                        <Button key="confirm" type="primary" loading={this.state.loading} disabled={this.isRecallConfirmDisabled()} onClick={this.handleRecallOk}>确认</Button>,
                    ]}
                    width="500px"
                >
                    <textarea
                        className="recall-textarea"
                        value={this.state.recallContent}
                        onChange={this.onRecallContentChange}
                        style={{ width: '100%', height: 200, resize: 'vertical' }}
                        placeholder="请输入撤回原因"
                    />
                </Modal>
                <Modal
                    title="操作日志"
                    visible={this.state.logModalVisible}
                    onCancel={this.hideLogModal}
                    maskClosable={false}
                    footer={<Button onClick={this.hideLogModal}>关闭</Button>}
                    width="900px"
                >
                    <Spin spinning={this.state.logLoading}>
                        <Table
                            dataSource={this.state.logData}
                            rowKey="majorEventSuspiciousId"
                            pagination={false}
                            columns={[
                                { title: '操作', dataIndex: 'type', key: 'type', width: 100, render: (text) => this.getTypeDescription(text) },
                                { title: '操作时间', dataIndex: 'operateTime', key: 'operateTime', width: 170 },
                                { title: '修改人', dataIndex: 'modifierName', key: 'modifierName', width: 100, render: (text) => text || '' },
                                { title: '提出人', dataIndex: 'proposerName', key: 'proposerName', width: 100, render: (text) => text || '' },
                                { title: '回复人', dataIndex: 'replierName', key: 'replierName', width: 100, render: (text) => text || '' },
                                { title: '内容', dataIndex: 'suspiciousContent', key: 'suspiciousContent', render: (text) => <div style={{ maxHeight: 80, overflowY: 'auto', whiteSpace: 'pre-wrap' }}>{text || ''}</div> },
                            ]}
                        />
                    </Spin>
                </Modal>
            </div>
        );
    }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/execute/importantEvent/Page.js